import constate from 'constate';

import { useAgenticChat } from './useAgenticChat';

export type { AgenticChatController } from './useAgenticChat';

export const [AgenticChatProvider, useAgenticChatContext] = constate(useAgenticChat);
